export const BLOG_HEADER_TITLE = "RCP w praktyce: agencje, budownictwo, prawo i koszty";

export const BLOG_DEFAULT_DESCRIPTION =
  "Praktyczna wiedza o rejestracji czasu pracy i RCP. Artykuły dla agencji pracy tymczasowej, firm budowlanych i działów HR: przepisy, nadużycia, rozliczanie projektów i cyfrowa transformacja procesów.";

export const BLOG_CATEGORIES = [
  {
    id: "rcp",
    name: "Rejestracja Czasu Pracy i RCP",
    label: "RCP i Rejestracja",
    color: "#1D4ED8",
    bgColor: "#DBEAFE",
    borderColor: "#93C5FD",
    description:
      "Fundament skutecznej ewidencji czasu pracy: wdrożenia RCP, porównanie metod rejestracji i dobre praktyki dla firm terenowych.",
  },
  {
    id: "prawo",
    name: "Prawo Pracy i Przepisy",
    label: "Prawo Pracy",
    color: "#7C3AED",
    bgColor: "#EDE9FE",
    borderColor: "#C4B5FD",
    description:
      "Aktualne przepisy prawa pracy i interpretacje pod ewidencję czasu pracy: PIP, nadgodziny, legalny monitoring i zgodność procesów HR.",
  },
  {
    id: "naduzycia",
    name: "Zapobieganie Nadużyciom i Oszustwom",
    label: "Nadużycia i Oszustwa",
    color: "#B45309",
    bgColor: "#FEF3C7",
    borderColor: "#FCD34D",
    description:
      "Jak wykrywać i ograniczać nadużycia w rozliczaniu czasu pracy: konkretne scenariusze strat finansowych i praktyczne mechanizmy kontroli.",
  },
  {
    id: "projekty",
    name: "Zarządzanie Projektami i Kosztami",
    label: "Projekty i Koszty",
    color: "#047857",
    bgColor: "#D1FAE5",
    borderColor: "#6EE7B7",
    description:
      "Artykuły o rentowności projektów i kontroli kosztów pracy: od raportowania godzin po precyzyjne rozliczenia zleceń i kontraktów.",
  },
  {
    id: "transformacja",
    name: "Cyfrowa Transformacja i HR",
    label: "Transformacja HR",
    color: "#BE185D",
    bgColor: "#FCE7F3",
    borderColor: "#F9A8D4",
    description:
      "Nowoczesne zarządzanie personelem i automatyzacja procesów kadrowych: trendy HR, self-service i praktyczne wdrożenia digitalizacji.",
  },
];

const normalizeCategoryKey = (value) => String(value || "").trim().toLowerCase();

const categoriesByName = new Map(
  BLOG_CATEGORIES.flatMap((category) => [
    [normalizeCategoryKey(category.id), category],
    [normalizeCategoryKey(category.name), category],
    [normalizeCategoryKey(category.label), category],
  ])
);

export const splitPostCategories = (categoryValue = "") => {
  if (!categoryValue) {
    return [];
  }

  if (Array.isArray(categoryValue)) {
    return splitPostCategories(categoryValue.join("|"));
  }

  const dedupe = new Set();

  return String(categoryValue)
    .split(/[|,]/)
    .map((category) => category.trim())
    .filter((category) => {
      if (!category) {
        return false;
      }

      const normalized = normalizeCategoryKey(category);
      if (dedupe.has(normalized)) {
        return false;
      }

      dedupe.add(normalized);
      return true;
    });
};

export const getCategoryMetaByName = (categoryName) => {
  if (!categoryName) {
    return null;
  }

  return categoriesByName.get(normalizeCategoryKey(categoryName)) || null;
};

export const isKnownCategory = (categoryName) =>
  Boolean(getCategoryMetaByName(categoryName));

export const serializePostCategories = (categoryNames = []) =>
  splitPostCategories(categoryNames)
    .map((categoryName) => getCategoryMetaByName(categoryName)?.name || categoryName)
    .join(" | ");
